/** React component to display a note
 *  It has a tooltip that displays the note when the user hovers over the note
 *  It opens edit note modal when the user clicks on the note
 **/

import React, { useState } from 'react';
import { Box } from '@mui/material';
import TwTooltip from '../TwTooltip/TwTooltip';

interface TwNotesPreviewProps {
  value: string; // note value
  EditNoteModal: React.ComponentType<{ open: boolean; onClose: () => void }>; // edit note modal component
}

const TwNotesPreview: React.FC<TwNotesPreviewProps> = ({ value, EditNoteModal }) => {
  const [notesOpen, setNotesOpen] = useState<boolean>(false);

  return (
    <>
      <TwTooltip title={value} placement="top">
        <Box
          sx={{
            width: 'auto',
            whiteSpace: 'nowrap',
            overflowX: 'hidden',
            textOverflow: 'ellipsis',
            paddingRight: '20px'
          }}
          onClick={(e): void => {
            e.stopPropagation();
            setNotesOpen(true);
          }}
        >
          {value || '-'}
        </Box>
      </TwTooltip>
      <EditNoteModal open={notesOpen} onClose={(): void => setNotesOpen(false)} />
    </>
  );
};

export default TwNotesPreview;
